
import React, { useState, useEffect} from 'react';
import axios from 'axios';

import {
  Button
} from "reactstrap";

import { useTranslation } from 'react-i18next';

// core components
import Navbar from "./layouts/Navbar.js";
import Footer from "./layouts/Footer.js";

import '../assets/css/Service.css'

// Image import
import overview1Img1 from '../assets/img/overview_img1.jpg';
import overview1Img2 from '../assets/img/overview_img2.jpg';
import overview2Img from '../assets/img/overview_img3.png';

import technologyImgKor from '../assets/img/technology_img1_kor.png';
import technologyImgEng from '../assets/img/technology_img1_eng.png';

import organizationImg1 from '../assets/img/organization_img1.png';
import organizationImg2 from '../assets/img/organization_img2.png';

import structureBg from '../assets/img/phone.png';

import LSIM_PEPL from './monitoring/LSIM_PEPL.js';
import LSIM_IE from './monitoring/LSIM_IE.js';
import LSPS from './monitoring/LSPS.js';
import LSRS from './monitoring/LSRS.js';

// Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";


  export default function LoneSmart() {
  const { t, i18n } = useTranslation();
  const technologyImg = i18n.language?.startsWith('ko') ? technologyImgKor : technologyImgEng;

  useEffect(() => {
    const lang = localStorage.getItem('lang') || 'ko';
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [i18n]);

  // Tab Action
  const [tabSelect, setTabSelect] = useState('Tab1'); // 초기 활성 탭 설정
  const handleTabChange = (tabId) => {
    setTabSelect(tabId);
    setSubTabSelect('subTab1');
  };

  const [subTabSelect, setSubTabSelect] = useState('subTab1'); // 초기 활성 탭 설정
  const handleSubTabChange = (tabId) => {
    setSubTabSelect(tabId);
  };

  //LONE-Smart 모니터링 탭 중 권한 체크
  const [roleCheck, setRoleCheck] = useState('');

  useEffect(() => {

    let profileRequest;

    //get-session 이후 실행(1초)
    setTimeout(() => {

      async function getUserInfo() {
        profileRequest = await axios.get(`/profile/getUserInfo`,
        { baseURL : process.env.REACT_APP_SERVER_URL },
        {
          withCredentials: true
        })
        .then((response) => {

          profileRequest = response.data;
          const userInfoData = profileRequest.userInfo;

          setRoleCheck(userInfoData.role);
          
        })
        .catch((error) => {
        });
      }
      getUserInfo();

    }, 100); // 시간을 밀리초 단위로 설정 (1초 = 1000 밀리초)
  });

    return (
      <>
      <Navbar />
      <div className="wrapper">

        <div id="LoneSmartHeader" className="Hero">
          <div className="HeaderSection">
            <div className="HeaderSectionTxtBox">
              <div className="HeaderSectionSubTitle fadeDivide">{t('GNSS Service')}</div>
              <div className="HeaderSectionTitle fadeDivide">LONE-Smart</div>
              <div className="HeaderSectionTxt fadeDivide">{t('GNSS.Description')}</div>
            </div>
          </div>
        </div>

        <div className="Banner">
          <div className="TabArea fadeDivide" style={{borderBottom:'1px #005E98 solid'}}>
            <div 
              className={tabSelect === 'Tab1' ? 'Tab TabSelect' : 'Tab TabDeSelect'}
              onClick={() => handleTabChange('Tab1')}
            >{t('LoneSmart.TabOverview')}</div>
            <div 
              className={tabSelect === 'Tab2' ? 'Tab TabSelect' : 'Tab TabDeSelect'}
              onClick={() => handleTabChange('Tab2')}
            >{t('LoneSmart.TabMonitoring')}</div>
          </div>
        </div>

        <div className="TabContents">
          {tabSelect === 'Tab1' &&
            // Tab1 Content Start
            <div id="TabWrapper">
              <div id="Overview">
                <div className="Section">
                  <div className="SectionHeaderFull">
                    <div className="SectionHeaderTxtbox">
                      <div className="SectionHeaderCategory CategoryDark fadeDivide">Overview</div>
                      <div className="SectionHeaderTitle fadeDivide">
                        <span className="SectionHeaderTitleDesc fadeDivide">{t('LoneSmart.Overview.TitleDesc')}</span>
                        <span className="SectionHeaderTitleMain fadeDivide">{t('LoneSmart.Overview.TitleMain')}</span>
                      </div>
                      <div className="SectionHeaderDescription fadeDivide">
                        <span>{t('LoneSmart.Overview.SubtitleLine1')}</span><span className="breakPointAdd"><br/></span>
                        <span style={{fontWeight:700}}>{t('LoneSmart.Overview.SubtitleLine2')}</span>
                      </div>
                    </div>
                  </div>
                  <div className="SectionContents">
                    <div className="OverviewContent">
                      <div className="OverviewImgBox">
                        <img className="Img2 fadeDivide" src={overview1Img1} alt="LONE-Smart Overview"/>
                        <img className="Img2 fadeDivide" src={overview1Img2} alt="LONE-Smart Overview"/>
                      </div>
                      <div className="OverviewText">
                        <div className="Overview1TextBoxes">
                          <div className="Overview1TextBox fadeDivide">
                            <div className="Overview1TextBoxTitle">{t('LoneSmart.Overview.MountainAccidentTitle')}</div>
                            <div className="Overview1TextBoxNumber">{t('LoneSmart.Overview.MountainAccidentYear')}<br/>{t('LoneSmart.Overview.MountainAccidentCount')}</div>
                          </div>
                          <div className="Overview1TextBox fadeDivide">
                            <div className="Overview1TextBoxTitle">
                              <span className="smallText">{t('LoneSmart.Overview.LostPeopleDetail')}<br/></span>
                              <span className="highlightText">{t('LoneSmart.Overview.MissingReport')}</span>
                            </div>
                            <div className="Overview1TextBoxNumber">{t('LoneSmart.Overview.MissingYear')}<br/>{t('LoneSmart.Overview.MissingCount')}</div>
                          </div>
                        </div>
                        <div className="Overview1TextBoxes fadeDivide">
                          <div className="ProductDescription">
                              {t('LoneSmart.Overview.DescriptionLine1')}<br/>
                              <span className="ProductDescriptionBold">
                                {t('LoneSmart.Overview.DescriptionBoldStart')}<br/>
                              </span>
                              {t('LoneSmart.Overview.DescriptionLine2')}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="OverviewContent">
                      <div className="OverviewText">
                        <div className="Grid4TextBoxes">
                          <div className="Grid4TextBox fadeDivide">
                            {t('LoneSmart.Overview.GridKASS')}
                          </div>
                          <div className="Grid4TextBox fadeDivide">
                            {t('LoneSmart.Overview.GridHighSpeed')}
                          </div>
                          <div className="Grid4TextBox fadeDivide">
                            {t('LoneSmart.Overview.GridHighPrecision')}
                          </div>
                          <div className="Grid4TextBox fadeDivide">
                            {t('LoneSmart.Overview.GridIntegrity')}
                          </div>
                        </div>
                        <div id="OverviewText2" className="fadeDivide">
                          <span style={{fontSize: 20, fontWeight: '400'}}>{t('LoneSmart.Overview.SummaryLine1')}<br/>{t('LoneSmart.Overview.SummaryLine2')}<br/>{t('LoneSmart.Overview.SummaryLine3')}<br/></span>
                          <span style={{fontSize: 26, fontWeight: '700'}}>{t('LoneSmart.Overview.SummaryTitle')}</span>
                        </div>
                      </div>
                      <div className="OverviewImgBox">
                        <img id="Overview2Img" src={overview2Img} className="fadeDivide" alt="LONE-Smart Overview"/>
                        <div className="ProductTitle fadeDivide" style={{marginTop:'20px'}}>LONE-Smart</div>
                        <div id="Overview2ImgText" className="fadeDivide">
                          <span style={{fontWeight: '700'}}>LO</span>cation
                          <span style={{fontWeight: '700'}}> N</span>otification
                          <span style={{fontWeight: '700'}}> E</span>mergency service with 
                          <span style={{fontWeight: '700'}}> Smart</span>phone
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div id="Technology">
                <div className="Section">
                  <div className="SectionHeaderFull fadeDivide">
                    <div className="SectionHeaderTxtbox">
                      <div className="SectionHeaderCategory CategoryBright">Technology</div>
                      <div className="SectionHeaderTitle whiteFonts">
                        <div className="SectionHeaderTitleDesc">{t('LoneSmart.Technology.TitleDesc')}</div>
                        <div className="SectionHeaderTitleMain">{t('LoneSmart.Technology.TitleMain')}</div>
                      </div>
                      </div>
                      <div className="SectionHeaderDescription whiteFonts">{t('LoneSmart.Technology.Description')}</div>
                  </div>
                  <div className="SectionContents">
                    <div id="Structure">
                      <div id="StructureImg" className="fadeDivide">
                        <img id="TechnologyImg" src={technologyImg} alt="LONE-Smart Technology"/>
                      </div>
                      <div id="Organization" className="fadeDivide">
                        <div id="OrganizationLogos">
                          <div className="ContentLogo">
                            <img className="OrganizationImg" src={organizationImg1} alt="LONE-Smart Technology"/>
                            <div className="LogoTitle">{t('LoneSmart.Technology.CenterA')}</div>
                          </div>
                          <div className="ContentLogo">
                            <img className="OrganizationImg" src={organizationImg2} alt="LONE-Smart Technology"/>
                            <div className="LogoTitle">{t('LoneSmart.Technology.CenterB')}</div>
                          </div>
                        </div>
                        <div className="OrganizitionTitle">{t('LoneSmart.Technology.ProductionCenter')}</div>
                      </div>
                    </div>
                    <div id="System">
                      <div id="SysBgBox">
                        <img id="StructureBg" src={structureBg}  className="fadeDivide" alt="LONE-Smart Technology"/>
                        <div id="SysContentsBox">
                          <div className="SysContent fadeDivide">
                            <span className="SysContentTitle">{t('LoneSmart.Technology.SysApiTitle')}</span><br/>
                            {t('LoneSmart.Technology.SysApiDescription')}
                          </div>
                          <div className="SysContent fadeDivide">
                            <span className="SysContentTitle">{t('LoneSmart.Technology.SysManagementTitle')}</span><br/>
                            {t('LoneSmart.Technology.SysManagementDescription')}
                          </div>
                          <div className="SysContent lineBold fadeDivide">
                            <span className="SysContentTitle">{t('LoneSmart.Technology.SysAlertAppTitle')}</span><br/>
                            {t('LoneSmart.Technology.SysAlertAppDescription')}
                          </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div id="Features">
                <div className="Section">
                  <div className="SectionHeaderFull fadeDivide">
                    <div className="SectionHeaderTxtbox" >
                      <div className="SectionHeaderCategory CategoryDark">Features</div>
                      <div className="SectionHeaderTitle">{t('LoneSmart.Features.Title')}</div>
                      <div className="SectionHeaderDescription">{t('LoneSmart.Features.Description')}</div>
                    </div>
                  </div>
                  <div className="SectionContents fadeDivide">
                    <div className="SubTabHeader">
                      <div
                        className={subTabSelect === 'subTab1' ? 'subTab subTabSelect' : 'subTab'}
                        onClick={() => handleSubTabChange('subTab1')}>{t('LoneSmart.Features.Tab1')}</div>
                      <div
                        className={subTabSelect === 'subTab2' ? 'subTab subTabSelect' : 'subTab'}
                        onClick={() => handleSubTabChange('subTab2')}>{t('LoneSmart.Features.Tab2')}</div>
                      <div
                        className={subTabSelect === 'subTab3' ? 'subTab subTabSelect' : 'subTab'}
                        onClick={() => handleSubTabChange('subTab3')}>{t('LoneSmart.Features.Tab3')}</div>
                      <div
                        className={subTabSelect === 'subTab4' ? 'subTab subTabSelect' : 'subTab'}
                        onClick={() => handleSubTabChange('subTab4')}>{t('LoneSmart.Features.Tab4')}</div>
                      <div
                        className={subTabSelect === 'subTab5' ? 'subTab subTabSelect' : 'subTab'}
                        onClick={() => handleSubTabChange('subTab5')}>{t('LoneSmart.Features.Tab5')}</div>
                    </div>
                    {subTabSelect === 'subTab1' &&
                    <div className="subTabContent fadeDivide">
                        <div className="subTabContentText">
                          <span>⦁ {t('LoneSmart.Features.Tab1ContentLine1')}<br/></span>
                          <span className="textIndent">* {t('LoneSmart.Features.Tab1ContentNote')}<br/></span>
                          <span>⦁ {t('LoneSmart.Features.Tab1ContentLine2')}<br/>⦁ {t('LoneSmart.Features.Tab1ContentLine3')}<br/>⦁ {t('LoneSmart.Features.Tab1ContentLine4')}</span>
                        </div>
                    </div>
                    }
                    {subTabSelect === 'subTab2' &&
                    <div className="subTabContent fadeDivide">
                        <div className="subTabContentText">
                          <span>⦁ {t('LoneSmart.Features.Tab2Content')}</span>
                        </div>
                    </div>
                    }
                    {subTabSelect === 'subTab3' &&
                    <div className="subTabContent fadeDivide">
                        <div className="subTabContentText">
                          <span>⦁ {t('LoneSmart.Features.Tab3Content')}</span>
                        </div>
                    </div>
                    }
                    {subTabSelect === 'subTab4' &&
                    <div className="subTabContent fadeDivide">
                        <div className="subTabContentText">
                          <span>⦁ {t('LoneSmart.Features.Tab4ContentLine1')}<br/></span>
                          <span>⦁ {t('LoneSmart.Features.Tab4ContentLine2')}</span>
                        </div>
                    </div>
                    }
                    {subTabSelect === 'subTab5' &&
                    <div className="subTabContent fadeDivide">
                        <div className="subTabContentText">
                          <span>⦁ {t('LoneSmart.Features.Tab5ContentLine1')}<br/></span>
                          <span>⦁ {t('LoneSmart.Features.Tab5ContentLine2')}<br/></span>
                          <span>⦁ {t('LoneSmart.Features.Tab5ContentLine3')}</span>
                        </div>
                    </div>
                    }
                  </div>
                </div>
              </div>


              <div id="LocationProvider">

              {/* <div className="SectionHeaderTitle whiteFonts" style={{lineHeight:'50px'}}>
                        <span className="SectionHeaderTitleDesc">{t('LoneSmart.Technology.TitleDesc')}<br/></span>
                        <span>{t('LoneSmart.Technology.TitleMain')}</span></div>
                      </div>
                      <div className="SectionHeaderDescription whiteFonts" style={{lineHeight:'50px'}}>{t('LoneSmart.Technology.Description')}</div>
                  </div>
                  <div className="SectionContents">
                    <div id="Structure">
                      <div id="StructureImg" className="fadeDivide">
                        <img id="TechnologyImg" src={technologyImg} alt="LONE-Smart Technology"/>
                      </div>
                      <div id="Organization" className="fadeDivide">
                        <div id="OrganizationLogos">
                          <div className="ContentLogo">
                            <img className="OrganizationImg" src={organizationImg1} alt="LONE-Smart Technology"/>
                            <div className="LogoTitle">{t('LoneSmart.Technology.CenterA')}</div>
                          </div>
                          <div className="ContentLogo">
                            <img className="OrganizationImg" src={organizationImg2} alt="LONE-Smart Technology"/>
                            <div className="LogoTitle">{t('LoneSmart.Technology.CenterB')}</div>
                          </div>
                        </div>
                        <div className="OrganizitionTitle">{t('LoneSmart.Technology.ProductionCenter')}</div>
                      </div>
                    </div>
                    <div id="System">
                      <div id="SysBgBox">
                        <img id="StructureBg" src={structureBg}  className="fadeDivide" alt="LONE-Smart Technology"/>
                        <div id="SysContentsBox">
                          <div className="SysContent fadeDivide">
                            <span className="SysContentTitle">{t('LoneSmart.Technology.SysApiTitle')}</span><br/>
                            {t('LoneSmart.Technology.SysApiDescription')}
                          </div>
                          <div className="SysContent fadeDivide">
                            <span className="SysContentTitle">{t('LoneSmart.Technology.SysManagementTitle')}</span><br/>
                            {t('LoneSmart.Technology.SysManagementDescription')}
                          </div>
                          <div className="SysContent lineBold fadeDivide">
                            <span className="SysContentTitle">{t('LoneSmart.Technology.SysAlertAppTitle')}</span><br/>
                            {t('LoneSmart.Technology.SysAlertAppDescription')}
                          </div>
                      </div> */}
                <div className="Section">
                  <div className="SectionHeaderFull fadeDivide">
                    <div className="SectionHeaderTxtbox" >
                      <div className="SectionHeaderCategory whiteFonts">LocationProvider</div>
                      <div className="SectionHeaderTitle whiteFonts">{t('LocationProvider Title')}</div>
                      <div className="SectionHeaderDescription whiteFonts" style={{lineHeight:'50px'}}>{t('LocationProvider Description1')}</div>
                    </div>
                  
                      <div className="SectionHeaderDescription whiteFonts">{t('LocationProvider Description2')}</div>
                      {/* <div className="GraphContent">
                        <div style={{justifyContent: 'flex-start', alignItems: 'center', gap: '5px', display: 'inline-flex', flexDirection: 'column'}}> */}
                            <div className="searchExampleText whiteFonts">{t('LocationProvider Note')}</div>
                            <div>
                                <Button
                                className="SearchBtn" style={{width:'200px'}}
                                onClick={() => {
                                    // window.open("../../variables/ITSPLocationProvider/ITSPLocationProvider.html", "_blank"); // Replace this with your URL
                                     //window.open(`${process.env.PUBLIC_DOMAIN}/variables/ITSPLocationProvider/ITSPLocationProvider.html`, "_blank");
                                     const baseUrl = process.env.APP_SERVER_URL || 'https://intospace.co.kr';
                                     window.open(`${baseUrl}/ITSPLocationProvider/ITSPLocationProvider.html`, "_blank");
                                    // window.open(`/variables/ITSPLocationProvider/ITSPLocationProvider.html`);
                                }}>
                                {t('API Manual')} <FontAwesomeIcon icon={faArrowRight} />
                                </Button>
                            </div>
                        </div>
                      
                    </div>
                  </div>
                  <div className="SectionContents fadeDivide">
                  </div>
                </div>
                
              
            // Tab2 Content End
          }
          {tabSelect === 'Tab2' &&
            // Tab2 Content
            <div id="Monitoring">
              <div className="Section">
                <div className="SectionHeaderFull">
                  <div className="SectionHeaderTxtbox">
                    <div className="SectionHeaderCategory CategoryDark">Monitoring</div>
                  </div>
                </div>
                <div className="SectionContents">
                  <div className="SubTabHeader">
                    <div 
                        className={subTabSelect === 'subTab1' ? 'subTab subTabSelect' : 'subTab'}
                        onClick={() => handleSubTabChange('subTab1')}
                        style={{width:'300px'}}>LSIM Position Error & Protection Level</div>
                    <div 
                        className={subTabSelect === 'subTab2' ? 'subTab subTabSelect' : 'subTab'}
                        onClick={() => handleSubTabChange('subTab2')}
                        style={{width:'300px'}}>LSIM Integrity Error</div>
                    {/* {roleCheck && roleCheck === "admin" ? ( */}
                    <div 
                        className={subTabSelect === 'subTab3' ? 'subTab subTabSelect' : 'subTab'}
                        onClick={() => handleSubTabChange('subTab3')}
                        style={{width:'300px'}}>LSPS</div>
                    {/* ) : (<></>)} */}
                    {roleCheck && roleCheck === "admin" ? (
                    <div 
                        className={subTabSelect === 'subTab4' ? 'subTab subTabSelect' : 'subTab'}
                        onClick={() => handleSubTabChange('subTab4')}
                        style={{width:'300px'}}>LSRS Monitoring</div>
                      ) : (<></>)}
                  </div>
                  {subTabSelect === 'subTab1' &&
                     <LSIM_PEPL roleCheck={roleCheck}/>
                  }
                  {subTabSelect === 'subTab2' &&
                    <LSIM_IE roleCheck={roleCheck}/>
                  }
                  {subTabSelect === 'subTab3' &&
                    <LSPS />
                  }
                  {subTabSelect === 'subTab4' &&
                    <LSRS />
                  }
                </div>
              </div>
            </div>
          }
        </div>

      </div>
      <Footer />
      </>
    )
  };